import React from 'react';

// StructuredData component to render JSON-LD structured data.
// Use a utility function, etc. to create the structured data object.
//

interface StructuredDataProps {
  structuredData?: string;
}

// This component was added to support structured data for breadcrumbs and could handle structured data types used in FAQ and Blog posts.
// The SEO component also supports strutured data, but it includes meta data and a header component which was not ideal for breadcrumbs.
// The NextJS project supports meta data in a different way, so the SEO component may be used in that project for the structured data since that's all it will have left.
const StructuredData: React.FC<StructuredDataProps> = ({ structuredData }) => {
  return structuredData ? (
    <script
      type='application/ld+json'
      dangerouslySetInnerHTML={{
        __html: structuredData,
      }}
    ></script>
  ) : null;
};

export default StructuredData;
